import { map } from 'lodash';

import { usePatientPageNavigate } from '@/Pages/SinglePatientDetails/PatientPageNavigation';

import { ReactComponent as LEFSIcon } from '../../../../assets/icons/timeline/lefsIcon.svg';
import useQuestionnairesService from '../../../../services/questionnairesService';
import type { IPatientQuestionnaire } from '../../../../services/questionnairesService/types';
import { patientTabsUrl } from '../../../SinglePatientDetails/types';
import { rangesProps } from '../RangesProps/LEFSRangesProps';

export default function useLEFSEvent(patientUuid: string) {
  const { LEFSQuestionnaires } = useQuestionnairesService(patientUuid);
  const { navigateToPatientPage } = usePatientPageNavigate();

  return map(LEFSQuestionnaires, ({ name, createdAt }: IPatientQuestionnaire) => {
    const score = name?.replace(/[^\d/]/g, '') ?? '';
    const scoreValue = (score.split('/')[0] && Number(score.split('/')[0])) || -1;
    return {
      name: score,
      date: createdAt,
      icon: LEFSIcon,
      ctaText: 'View LEFS',
      circle: {
        color: rangesProps.find((x) => scoreValue >= x.min && scoreValue <= x.max)?.color ?? '',
      },
      cta() {
        navigateToPatientPage(`/patients/${patientUuid}/${patientTabsUrl.activityLog}`);
      },
    };
  });
}
